export default __webpack_public_path__ + "static/media/close.52a9acad.svg";